import {Amount} from "@/model/amount";
import {PortalType} from "@/store/player/types";

export class PortalDto {
    placeId!: number;
    name!: string;
    desc!: string;
    atlasKey!: string;
    imageKey!: string;
    portalId!: string;
    price!: Amount;
    length!: number;
    discount!: DiscountDto;
    activatableDiscount!: number;
    portalType!: PortalType;
}

export class PortalOffer {
    portalId!: string;
    price!: number;
    name!: string;
    nameAccusative!: string;
    atlasKey!: string;
    imageKey!: string;
}

class DiscountDto {
    oldPrice!: Amount;
    fromDate!: string;
    toDate!: string;
}
